// 城乡居民养老保险缴费——微信，主流程
const wxMainRoutes = Array.from({ length: 11 }, (_, i) => ({
  path: `resident/wx/index${i + 1}`,
  name: `residentWxIndex${i + 1}`,
  component: () => import(`@/views/society/resident/wx/index${i + 1}.vue`)
}))

// 城乡居民养老保险缴费——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 11 }, (_, i) => ({
  path: `resident/zfb/index${i + 1}`,
  name: `residentZfbIndex${i + 1}`,
  component: () => import(`@/views/society/resident/zfb/index${i + 1}.vue`)
}))
// 城乡居民养老保险缴费——皖事通，主流程
const wstMainRoutes = Array.from({ length: 12 }, (_, i) => ({
  path: `resident/wst/index${i + 1}`,
  name: `residentWstIndex${i + 1}`,
  component: () => import(`@/views/society/resident/wst/index${i + 1}.vue`)
}))

export default {
  path: '/society',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 城乡居民养老保险缴费——微信，开始
    ...wxMainRoutes,

    // 城乡居民养老保险缴费——支付宝，主流程
    ...zfbMainRoutes,
    // 城乡居民养老保险缴费——皖事通，主流程
    ...wstMainRoutes
  ]
}
